import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Grid2 as Grid, Typography, Box } from '@mui/material';
export var StaticField = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.placeholder, placeholder = _b === void 0 ? 'Não informado' : _b, _c = _a.columns, columns = _c === void 0 ? 12 : _c;
    return (_jsx(Grid, { size: { xs: 12, md: columns }, children: _jsxs(Box, { children: [_jsx(Typography, { variant: "body2", color: "textSecondary", children: label }), _jsx(Typography, { variant: "body1", color: value ? 'textPrimary' : 'textSecondary', children: value || placeholder })] }) }));
};
